import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="disable-button"
export default class extends Controller {
  static targets = ["button", "checkbox"];

  toggleButton() {
    this.buttonTargets.forEach((button) => {
      button.disabled ? this.enableButton() : this.disableButton()
    })
  }

  enableButtonIfCheckboxesEnabled() {
    const allChecked = this.checkboxTargets.every((checkbox) => checkbox.checked)
    if (allChecked) {
      this.enableButton()
    } else {
      this.disableButton()
    }
  }

  enableButton() {
    this.buttonTargets.forEach((button) => {
      button.disabled = false
    })
  }

  disableButton() {
    this.buttonTargets.forEach((button) => {
      button.disabled = true
    })
  }
}
